import { useState, useEffect } from 'react'
import { Progress, Alert } from 'reactstrap'
import './FileProgress.css'

export default function FileProgress({ fileInfo }) {
  console.log('FileProgress rendered: ', fileInfo)

  const [percentage, setPercentage] = useState(0)
  const [errorText, setErrorText] = useState()
  const [uploaded, setUploaded] = useState(false)

  // passing empty array makes this run only on first render
  useEffect(() => {
    fileInfo.setPercentage = setPercentage
    fileInfo.setErrorText = setErrorText
    fileInfo.setUploaded = setUploaded
    // eslint-disable-next-line
  }, [fileInfo.setPercentage, fileInfo.setErrorText, fileInfo.setUploaded])

  let component = null
  if (errorText) {
    component = <Alert color="danger">{errorText}</Alert>
  } else {
    if (uploaded) {
      component = <Progress color="success" value={percentage}>Upload complete!</Progress>
    } else {
      if (percentage === 100) {
        component = <Progress animated value={percentage}>Updating database...</Progress>
      } else {
        component = <Progress value={percentage}>Uploading file...</Progress>
      }
    }
  }

  return (
    <div className="file-progress-container">
      <span>{fileInfo.file.name}</span>
      {component}
    </div>
  )
}
